module.exports = __webpack_public_path__ + "static/media/grid.01a1a1c2.svg";